import { Analytics } from '@cobliteam/analytics/src/Analytics';
import type { MediaView } from '@cobliteam/common-types/src';
import useCameraSafety from '@cobliteam/hooks/src/useCamera/useCameraSafety';
import { useTranslation } from '@cobliteam/i18n';
import { Button, Loading, Popover, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { getMediaSafetyOccurrences } from '../../../../../utils/mediaUtils';
import CobliCamPlayer from '../../../../Player/CobliCamPlayer';
import TagSafetyOccurrences from '../../../../Tag/TagSafetyOccurrences';

export interface DialogMediaBodyProps {
  mediaView?: MediaView;
}

const DialogMediaBody = ({ mediaView }: DialogMediaBodyProps) => {
  const { t } = useTranslation('ui-business');
  const { getCameraSafetyOccurrences } = useCameraSafety();
  const { data: occurrences } = getCameraSafetyOccurrences();

  if (!mediaView)
    return (
      <div className='flex h-72 w-full items-center justify-center'>
        <Loading />
      </div>
    );

  const safetyOccurrences = getMediaSafetyOccurrences(t, mediaView.mediaInfo, occurrences);
  const hasNoOccurrences = safetyOccurrences === null || safetyOccurrences.length === 0;

  return (
    <div className='mt-6'>
      <CobliCamPlayer mediaView={mediaView} />
      <div className='mt-4 flex items-center'>
        <Typography variant='text-md-semibold' color='secondary'>
          {t('dialogs.media.occurrences')}
        </Typography>
        <Popover>
          <Popover.Trigger>
            <Button color='default' variant='ghost' size='sm' icon={<Icon name='info' />} />
          </Popover.Trigger>
          <Popover.Content align='start' side='top' portal={false}>
            <Typography variant='text-md-semibold' color='secondary' className='pb-2'>
              {t('dialogs.media.occurrences')}
            </Typography>
            <Typography variant='text-md' color='secondary'>
              {t('dialogs.media.occurrences_tooltip')}
            </Typography>
            <Button
              className='px-0'
              variant='link'
              onClick={() => {
                window.open('https://suporte.cobli.co/como-registrar-ocorr%C3%AAncias-nos-v%C3%ADdeos');

                Analytics.track('Occurrences FAQ Button Clicked');
              }}
            >
              {t('dialogs.media.learn_more')}
            </Button>
          </Popover.Content>
        </Popover>
      </div>
      {safetyOccurrences === null || safetyOccurrences.length === 0}
      {hasNoOccurrences ? (
        <Typography variant='text-sm' color='secondary'>
          {t('dialogs.media.no_occurrences')}
        </Typography>
      ) : (
        <TagSafetyOccurrences safetyOccurrences={safetyOccurrences} aiVideoTags={mediaView?.aiVideoTags} />
      )}
    </div>
  );
};

export default DialogMediaBody;
